
import React, { PureComponent } from 'react'
import { Button, Modal, Col } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'

class DocumentVisualizationMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = { }
  }

  submitDocumentVisualization (values) {
    var documentVisualization = {
      documentVisualizationId: values.documentVisualizationId,
      originDossierSubTypeId: values.originDossierSubTypeId,
      destDossierSubTypeId: values.destDossierSubTypeId,
      documentTypeUseId: values.documentTypeUseId
    }

    this.props.actions.submitDocumentVisualization(documentVisualization)
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.documentVisualization)
    }
  }

  render () {
    const {
      t, showModal, handleSubmit,
      combos: { dossierSubtypesCombo, documentTypeUseCombo }
    } = this.props

    const tKey = 'MASTERS.DOCUMENT_VISUALIZATION.'
    return (
      <Modal id="documentVisualizationMasterModal" show={showModal} onHide={this.props.actions.closeDocumentVisualizationMasterModal} className="_nf">
        <Modal.Header closeButton>
          <Modal.Title>{t(`${tKey}DOCUMENT_VISUALIZATION`)}</Modal.Title>
        </Modal.Header>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitDocumentVisualization.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                name="originDossierSubTypeId"
                placeholder={t(`${tKey}ORIGIN_SUBTYPE`)}
                valueKey="id"
                labelKey="value"
                options={dossierSubtypesCombo}
              />
              <Field
                component={InputSelect}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                name="destDossierSubTypeId"
                placeholder={t(`${tKey}DESTINY_SUBTYPE`)}
                valueKey="id"
                labelKey="value"
                options={dossierSubtypesCombo}
              />
              <Field
                component={InputSelect}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                name="documentTypeUseId"
                placeholder={t(`${tKey}TYPE_USE`)}
                valueKey="id"
                labelKey="value"
                options={documentTypeUseCombo}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R" >
              <Button type="submit" className="_Btn new">
                {t('MASTERS.SAVE')}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}
const validate = (values, props) => {
  const error = { }

  if (!values.originDossierSubTypeId) {
    error.originDossierSubTypeId = props.t('MASTERS.DOCUMENT_VISUALIZATION.VALIDATION.ORIGIN_SUBTYPE')
  }
  if (!values.destDossierSubTypeId) {
    error.destDossierSubTypeId = props.t('MASTERS.DOCUMENT_VISUALIZATION.VALIDATION.DESTINY_SUBTYPE')
  }
  if (!values.documentTypeUseId) {
    error.documentTypeUseId = props.t('MASTERS.DOCUMENT_VISUALIZATION.VALIDATION.TYPE_USE')
  }
  return error
}

export default reduxForm({
  form: 'documentVisualizationModal',
  validate
})(DocumentVisualizationMasterModal)
